import { Icon } from '@types';

export const NavigateBefore = ({ customStyles, handleClick }: Icon) => {
	return (
		<svg
			className={customStyles}
			xmlns="http://www.w3.org/2000/svg"
			height="24px"
			viewBox="0 0 24 24"
			width="24px"
			fill="#000000"
			onClick={e => {
				if (handleClick) handleClick(e);
			}}
		>
			<path d="M0 0h24v24H0V0z" fill="none" />
			<path d="M15.61 7.41L14.2 6l-6 6 6 6 1.41-1.41L11.03 12l4.58-4.59z" />
		</svg>
	);
};
